













































































































































import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import LoanPerk from '~/components/car/classifieds/view/partials/loans/perks/LoanPerk.vue'
import { OnlineLoanType } from '~/constants/loan/loans'
import { defineComponentTranslations } from '~/utils/i18n'
import { useI18n } from '~/compositions/i18n'
import { useBlackFriday } from '~/compositions/black-friday'
import { TBI_BLACK_FRIDAY_INTEREST } from '~/constants/loan/tbi'

export default defineComponent({
  props: {
    loanType: {
      type: String as PropType<OnlineLoanType>,
      required: false,
      default: OnlineLoanType.AUTO
    }
  },
  components: { LoanPerk },
  setup() {
    const { isWithinTbiBlackFridayPeriod } = useBlackFriday()
    const { t } = useI18n()
    const isBlackFriday = isWithinTbiBlackFridayPeriod()
    return {
      OnlineLoanType,
      isBlackFriday,
      t,
      TBI_BLACK_FRIDAY_INTEREST
    }
  },
  i18n: defineComponentTranslations({
    santander_perk_1: {
      en: '{bold} application process',
      el: '{bold} διαδικασία αίτησης'
    },
    santander_perk_1_bold: {
      en: 'Fast & easy',
      el: 'Γρήγορη & εύκολη'
    },
    santander_perk_2: {
      en: '{bold} response to your email',
      el: '{bold} απάντηση στο email'
    },
    santander_perk_2_bold: {
      en: 'Immediate',
      el: 'Γρήγορη'
    },
    santander_perk_3: {
      en: '{bold} to the dealer by Santander',
      el: '{bold} του Εμπόρου από τη Santander'
    },
    santander_perk_3_bold: {
      en: 'Direct payment',
      el: 'Απευθείας εξόφληση'
    },
    santander_perk_4: {
      en: '{bold} prime interest rate',
      el: '{bold} προνομιακό επιτόκιο'
    },
    santander_perk_4_bold: {
      en: 'Fixed',
      el: 'Σταθερό'
    },
    santander_perk_5: {
      en: '{bold} by connecting to gov.gr',
      el: '{bold} με σύνδεση στο gov.gr'
    },
    santander_perk_5_bold: {
      en: 'Instant identification',
      el: 'Άμεση ταυτοποίηση'
    }
  })
})
